import { lazy } from 'react'

/**
 * Módulo: Mercado (inteligencia de mercado sobre Market Pro / Real Trends).
 * Explorador on-demand para el consultor: pregunta por categoría, vendedor o
 * producto en un rango de fechas → BigQuery responde el ranking/serie fresco.
 * Ver docs/modulo_mercado.md. Gateado a staff (admin/consultor).
 */
export default {
  id: 'mercado',
  nombre: 'Mercado',
  descripcion: 'Inteligencia de mercado: explorá categorías, vendedores y productos por rango de fechas',
  icono: 'bar-chart-2',
  tipo: 'estrategia',
  version: '0.1.0',
  // Herramienta de trabajo del consultor: solo staff (NO cliente).

  routes: [
    { path: 'mercado/explorador', component: lazy(() => import('./pages/Explorador')) },
    // Conocimiento Ecosistema (14-jul-2026): agregados anónimos cross-vendedores.
    // Primera sección: Costos ML. Ver docs/conocimiento-ecosistema-rentabilidad-inferida.md
    { path: 'conocimiento/costos-ml', component: lazy(() => import('./pages/ConocimientoCostosML')) },
    // Salud del Catálogo (T2/T3, plan PLAN_conocimiento-salud-catalogo.md).
    { path: 'conocimiento/salud-reclamos', component: lazy(() => import('./pages/ConocimientoSaludReclamos')) },
    { path: 'conocimiento/salud-preguntas', component: lazy(() => import('./pages/ConocimientoSaludPreguntas')) },
  ],

  // "Explorador de mercado" se mudó al grupo GESTIÓN (gestion/config.js) el
  // 7-jul (reporte qNYaHszw) — herramienta diaria del consultor, vive debajo
  // de Mensajes. La ruta /mercado/explorador sigue acá (routes) y el módulo
  // sigue gateado por permisoModulos ['mercado'] (App.jsx monta las rutas por
  // eso, no por menuItems). Con menuItems vacío el grupo "Mercado" ya no se
  // dibuja en el sidebar (Layout saltea módulos sin ítems) — es lo buscado.
  menuItems: [],

  features: ['mercado-explorador'],

  // Incluye el código de cada ítem del menú cuya ruta monta este módulo: lo exige `src/core/lib/menuRutaPermiso.guard.test.js`.
  permisoModulos: ['mercado', 'conocimiento'],

}
